import { render, staticRenderFns } from "./EmployeeMovementDelete.vue?vue&type=template&id=044c79c2&scoped=true&"
import script from "./EmployeeMovementDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeeMovementDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c79c2",
  null
  
)

export default component.exports